import { StyleSheet } from "~/ui/primitives"
import { GlobalToastProps } from "./types"
import React from "react"
import styled from '~/ui/styled'
import type { Theme } from '~theme/styled' 
import { Text as TextCore } from "~widgets/text"
import { useStores } from "~models"
import { observer } from "mobx-react-lite"
import { useSafeAreaInsets } from "~/ui/safe-area"

const Box = styled.View`
  justify-content: space-between;
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 2;
  padding: ${({ theme }) => theme.space.sm} 15px;
`

const Column = styled.View<{ theme: Theme }>`
  border-color: #999;
  border-width: ${StyleSheet.hairlineWidth}px;
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: ${({ theme }) => theme.space.sm};
  z-index: 2;
  background-color: white;
`
const TitleText = styled(TextCore)`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  color: rgb(0, 0, 0);
  font-weight: bold;
`

const Text = styled(TextCore)`
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: rgb(0, 0, 0);
  /* text-align: center; */
  padding-top: ${({ theme }) => theme.space.sm};
`
const SumitText = styled(TextCore)`
  font-size: ${({ theme }) => theme.fontSizes.md};
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
`

const Row = styled.View`
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
`
const TouchableOpacity = styled.TouchableOpacity`
  /* flex: 1; */
  padding: 0 10px;
`

const GlobalToast: React.FC<GlobalToastProps> = () => {
  const insets = useSafeAreaInsets()
  const {
    globalToastStore: {
      title,
      content,
      isGlobalToastShowing,
      cleanGlobalToast,
      handleSubmit,
      handleCancel,
      submitBtnText,
      cancelBtnText,
    },
  } = useStores()

  return (
    <>
      {isGlobalToastShowing && (
        <Box
          style={{
            top: insets.top,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 5 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 5,
          }}
        >
          <Column>
            <TitleText>{title}</TitleText>
            <Text style={{ width: "auto" }}>{content}</Text>
            <Row>
              <TouchableOpacity
                onClick={() => {
                  cleanGlobalToast()
                  handleCancel && handleCancel()
                }}
              >
                <Text>{cancelBtnText || "取消"}</Text>
              </TouchableOpacity>

              <TouchableOpacity
                onClick={() => {
                  cleanGlobalToast()
                  handleSubmit && handleSubmit()
                }}
              >
                <SumitText>{submitBtnText || "查看"}</SumitText>
              </TouchableOpacity>
            </Row>
          </Column>
        </Box>
      )}
    </>
  )
}
export default observer(GlobalToast)
